export const cubeFileKey = 'cubeFileKey';
export const indexOpenModalKey = 'indexOpenModalKey';
export const marketChannel = 'marketChannel';
export const indexServiceNotice = 'indexServiceNotice';
export const aliH5PayKey = 'ALIH5PAYKEY';

export default {
  cubeFileKey,
  indexOpenModalKey,
  marketChannel,
  indexServiceNotice,
  aliH5PayKey,
};
